/* eslint-disable array-callback-return */
/* eslint-disable react/destructuring-assignment */
import { Cause } from './cause';
import { CollaboratorData } from './collaborator-data';
import { Header } from './header';
import { ReportContext } from './hooks/use-context';
import { ImmediateProvidences } from './immediate-providences';
import { InitialInfos } from './initial-infos';
import { LocationRef } from './location-ref';
import { Measures } from './measures';
import { OccurrenceDescription } from './occurrence-description';
import type {
  EventReportData,
  ParsedQuestions,
  QuestionsReporData,
} from './types';

export function GoiasaUnsafeActReport(props: { reportData: EventReportData }) {
  // Question ID mapping based on the specifications
  const QUESTIONS_MAP: Record<string, keyof ParsedQuestions> = {
    // Initial infos
    'c314fdac-a66d-4d8c-bdbe-3a9aa63c4e79': 'reincidente', // Reincidente?
    '1c6ece3d-bbca-4ab1-808a-0e9c736aabaf': 'date', // Informe a data do ocorrido:
    'd6bcbd08-7e73-4bae-ac63-566372326d45': 'time', // Informe o horário do ocorrido:
    'd3658cce-8d68-4e48-860d-ec5420ef12c3': 'classification', // Classificação
    '68f35399-79c1-42f1-80a8-47b7240a8afa': 'area', // Informe a área:

    // Location reference
    'f0bc89b5-3e21-4a3a-bb49-6ae459860c1b': 'location_ref', // Informe a referência de localização:

    // Collaborator data
    '533c5b7a-34e8-4a54-bd00-3524209e22ba': 'name', // Nome: (collection question)
    'd961f01e-b9b9-4fc9-86c9-dff274f01e4c': 'cadastro', // Cadastro:
    '0703b20f-fd5c-485e-b0db-5d5e707e42ae': 'cargo', // Cargo:
    '352dcf07-9d05-46e0-9177-9d64f09c3159': 'area_atuacao', // Área de atuação:
    'e3a17071-00dc-41e0-aaa1-011e9c9df876': 'coordenador', // Coordenador:
    '796393be-6a60-4d47-9015-fb9cb1a0ee64': 'gestor', // Gestor:
    '02ba3ad4-1fc7-40f9-a367-818fc1f5f03e': 'record_responsible', // Responsável pelo Registro: (collection question)
    '374106ec-e403-4275-abb8-fbccb7136df2': 'record_responsible_text', // Responsável pelo Registro (text):

    // Occurrence description
    '7d2dfc23-47dc-408e-992f-7c74c5d8a3d8': 'occurrence_type', // Informe o tipo de ocorrência:
    '782369b2-a303-45ff-8eb4-7732a4f50e3d': 'occurence_description', // Descrição da Ocorrência:

    // Cause
    'a8daa8a0-9b25-4e5d-aeaf-85cdc4e6cdaf': 'cause', // Causa(s) Levantada(s):

    // Measures
    'c1a9071b-c517-408b-ad98-24e52b6b7a20': 'measures', // Medida(s) Proposta(s):

    // Immediate providences
    'a8a698e7-7d31-4ac7-83da-541dc50ea299': 'immediate_providences', // Proposta(s) Imediata(s):
  };

  const values = Array.isArray(props?.reportData?.body)
    ? props?.reportData?.body?.reduce((acc, item) => {
        item.sections?.map((section) =>
          section.questions.map((question) => {
            if (question?.question_id && QUESTIONS_MAP[question?.question_id])
              acc[QUESTIONS_MAP[question?.question_id]] = question;
          }),
        );
        return acc;
      }, {} as Partial<ParsedQuestions>)
    : {};

  const parsedProps: QuestionsReporData = {
    header: props?.reportData?.header,
    body: (values as unknown) as ParsedQuestions,
  };

  return (
    <ReportContext value={parsedProps}>
      <div>
        <div
          style={{
            height: '90%',
            width: '100vw',
            flex: 1,
            backgroundColor: 'white',
            fontFamily: 'sans-serif',
          }}
        >
          <div
            style={{
              margin: '1rem auto',
              height: 'auto',
              maxWidth: '64rem',
            }}
          >
            <Header />
            <div
              style={{
                height: '100%',
                width: '100%',
                borderWidth: '1px',
                borderStyle: 'solid',
                borderColor: '#000',
                backgroundColor: '#fff',
                padding: '1rem',
              }}
            >
              <InitialInfos />
              <LocationRef />
              <CollaboratorData />
              <OccurrenceDescription />
              <Cause />
              <Measures />
              <ImmediateProvidences />
            </div>
          </div>
        </div>
      </div>
    </ReportContext>
  );
}
